import { useEffect, useRef, useState } from "react";

interface DebouncedOptions {
  immediate?: boolean;
}

export function useDebouncedValue<T>(
  value: T,
  delay: number = 300,
  options: DebouncedOptions = {}
): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (options.immediate) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      setDebouncedValue(value);
      return;
    }

    timeoutRef.current = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [value, delay, options.immediate]);

  return debouncedValue;
}
